import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import useForgotPassword from "../../hooks/useForgotPassword";
import SafeImage from "../../components/common/SafeImage";

export default function Forgot() {
    const [phone_no, setPhoneNo] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const forgotPasswordMutation = useForgotPassword();

    const handleSubmit = (e) => {
        e.preventDefault();
        setError("");
        if (!phone_no.trim()) {
            setError("Phone number is required");
            return;
        }
        // Optionally validate phone number format here
        setIsLoading(true);
        forgotPasswordMutation.mutate(
            { phone_no },
            {
                onSuccess: (res) => {
                    setIsLoading(false);
                    if (res.status === "success") {
                        navigate("/otp", { state: { phone_no } });
                    } else {
                        setError(res.message || "Something went wrong.");
                    }
                },
                onError: (err) => {
                    setIsLoading(false);
                    const data = err?.response?.data || err;
                    setError(
                        (data?.errors?.phone_no && Array.isArray(data.errors.phone_no) && data.errors.phone_no[0]) ||
                        data?.message ||
                        "Failed to send reset link."
                    );
                }
            }
        );
    };

    return (
        <>
            {/* login section start */}
            <section className="log-in-section section-b-space">
                <Link to="/" className="logo-login">
                    <SafeImage src="assets/images/logo/1.png" className="img-fluid" alt="Logo" /></Link>
                <div className="container w-100">
                    <div className="row">
                        <div className="col-xl-5 col-lg-6 me-auto">
                            <div className="log-in-box">
                                <div className="log-in-title">
                                    <h3>Welcome To Go Home Express</h3>
                                    <h4>Enter your phone number</h4>
                                </div>
                                {error && (
                                    <div className="alert alert-danger" role="alert">{error}</div>
                                )}
                                <div className="input-box">
                                    <form className="row g-4" onSubmit={handleSubmit}>
                                        <div className="col-12">
                                            <div className="form-floating theme-form-floating log-in-form">
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    id="phone_no"
                                                    placeholder="Phone Number"
                                                    value={phone_no}
                                                    onChange={e => setPhoneNo(e.target.value)}
                                                    disabled={isLoading || forgotPasswordMutation.isLoading}
                                                    required
                                                />
                                                <label htmlFor="phone_no">Phone Number</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <button
                                                className="btn btn-animation w-100 justify-content-center"
                                                type="submit"
                                                disabled={isLoading || forgotPasswordMutation.isLoading}
                                            >
                                                {isLoading || forgotPasswordMutation.isLoading ? "Sending..." : "Send Link"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* login section end */}
        </>
    );
}